export class StatementRef {
    id;
    objectType = 'StatementRef';
    constructor(cfg) {
        this.init(cfg);
    }
    init(cfg = {}) {
        this.id = cfg.id;
    }
    toString() {
        return this.id;
    }
    asVersion(version = '1.0.3') {
        const result = {
            objectType: this.objectType,
            id: this.id
        };
        return result;
    }
    static fromJSON(stRefJSON) {
        const _stRef = JSON.parse(stRefJSON);
        return new StatementRef(_stRef);
    }
}
